var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tripId || _vm.stopId || _vm.shipmentId || _vm.orderId
    ? _c("div", { staticClass: "action-dropdown" }, [
        _c(
          "div",
          {
            staticClass: "recalculate-button",
            class: [
              { "sync-loader": _vm.isRecalculating || _vm.externalRecalculate },
            ],
          },
          [
            !_vm.isRecalculating && !_vm.externalRecalculate
              ? _c(
                  "md-button",
                  {
                    staticClass: "btn-blue md-just-icon md-round",
                    class: [{ "btn-disabled": _vm.enableRecalculate }],
                    attrs: {
                      disabled: _vm.enableRecalculate,
                      title: "Recalculate Rates",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.recalculateRates()
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("currency_exchange")])],
                  1
                )
              : _c("div", { staticClass: "btn-blue md-button" }, [
                  _c("div", { attrs: { id: "loading" } }),
                ]),
          ],
          1
        ),
        _vm.isAnyApprovalFeatureEnabled
          ? _c(
              "div",
              { staticClass: "approval-buttons" },
              [
                !_vm.disableApprovalButton
                  ? _c(
                      "md-button",
                      {
                        staticClass: "btn-green md-just-icon md-round",
                        class: [{ "btn-disabled": _vm.disableApprovalButton }],
                        attrs: {
                          disabled: _vm.disableApprovalButton,
                          title: "Approve",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.approveJobs()
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("thumb_up")])],
                      1
                    )
                  : _c(
                      "md-button",
                      {
                        staticClass: "btn-red md-just-icon md-round",
                        class: [{ "btn-disabled": _vm.disableUnapproveButton }],
                        attrs: {
                          disabled: _vm.disableUnapproveButton,
                          title: "Unapprove",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.unapproveJobs()
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("thumb_down")])],
                      1
                    ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          [
            _vm.stopId == null
              ? _c(
                  "md-button",
                  {
                    staticClass: "btn-blue md-just-icon md-round",
                    class: [{ "btn-disabled": _vm.disableUpdateTimeButton }],
                    attrs: {
                      title: "Update scheduled times",
                      disabled: _vm.disableUpdateTimeButton,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.openUpdateTimeModal()
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("access_time")])],
                  1
                )
              : _vm._e(),
            _c(
              "md-button",
              {
                staticClass: "md-just-icon md-round",
                class: [
                  {
                    "btn-disabled": _vm.disableServicePackageButton,
                  },
                  { "btn-orange": _vm.selectedRateGroupId != null },
                  { "btn-blue": _vm.selectedRateGroupId == null },
                ],
                attrs: {
                  disabled: _vm.disableServicePackageButton,
                  title: "Add/Update Service Package",
                },
                on: {
                  click: function ($event) {
                    return _vm.addServicePackage()
                  },
                },
              },
              [
                _c("md-icon", [
                  _vm._v(
                    _vm._s(
                      _vm.selectedRateGroupId
                        ? "store_mall_directory"
                        : "add_business"
                    )
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }